import { useMutation } from 'react-query'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { ManagementAddNewLoan } from 'services/loans/manager'
import posthog from 'posthog-js'

export default function useSetNewLoans() {
    const navigate = useNavigate()
    const { state } = useLocation()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IManagementBodyFirst) => {
            return ManagementAddNewLoan(payload)
        },
        onSuccess: (response, variables) => {
            posthog.capture('loan_grant_step_completed', {
                step: 'details',
                fund_id: (variables as any)?.moneyPool,
            })
            navigate('/loans/add-new/management/final', {
                state: {
                    payload: variables,
                    response: response,
                    loan_demand: state?.loan_demand,
                },
            })
        },
        onError: (error: any, variables) => {
            posthog.capture('loan_grant_failed', {
                step: 'details',
                fund_id: (variables as any)?.moneyPool,
                status: error?.response?.status,
            })
            if (error.response.data[0] === 'Interest cannot be more than 4%.') {
                toast.error('میزان کارمزد نباید بیش از 4 درصد مقدار وام باشد')
            } else {
                toast.error('خطایی رخ داده!')
            }
        },
    })

    return { isLoading, mutate }
}
